/*************************************************/
/* CHART                                         */
/*************************************************/

import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';

export function chart() {
    Chart.register(annotationPlugin);

    const generateAnnotations = (coordinates, labels) => {
        const annotations = {};

        coordinates.forEach((coordinate, index) => {
            if (coordinate.x !== null && coordinate.y !== null) { // Ensure valid coordinates
                const labelAnnotation = {
                    type: 'label',
                    backgroundColor: '#063a2f',
                    color: '#ffffff',
                    content: labels[index],
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    font: {
                        size: 20,
                    },
                    padding: 20,
                    xValue: coordinate.x,
                    yValue: coordinate.y,
                    yAdjust: 0,
                    display: false, // Initially hidden
                    id: `label-${index}` // Add ID for reference
                };

                annotations[`label-${index}`] = labelAnnotation;
            }
        });

        return annotations;
    };

    const generateMobileAnnotations = (coordinates, labels) => {
        const annotations = {};

        coordinates.forEach((coordinate, index) => {
            if (coordinate.x !== null && coordinate.y !== null) { // Ensure valid coordinates
                const labelAnnotation = {
                    type: 'label',
                    backgroundColor: '#063a2f',
                    color: '#ffffff',
                    content: labels[index],
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    font: {
                        size: 13,
                    },
                    padding: 10,
                    xValue: coordinate.x,
                    yValue: coordinate.y,
                    yAdjust: 0,
                    display: false, // Initially hidden
                    id: `label-${index}` // Add ID for reference
                };

                annotations[`label-${index}`] = labelAnnotation;
            }
        });

        return annotations;
    };

    const coordinates = [
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: null, y: null },
        { x: 25, y: 120 },
        { x: null, y: null },
    ];

    const mobileCoordinates = [
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
        { x: 6, y: 140 },
    ];

    const labels = [
        [''],
        [''],
        ['Emerging from the energy crisis,', 'the year started off with high prices', 'reinforced by a cold spell in late 2022. '],
        [''],
        [''],
        [''],
        [''],
        ['Above average temperatures,', 'demand reduction measures,', 'and high gas storage levels send power', 'and gas prices trending downwards.'],
        [''],
        [''],
        [''],
        ['Strike action at French LNG terminals', 'and North Sea Platforms cause supply', 'concern for gas filling season. '],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        ['Markets remain on edge;', 'however, prices continue their downward', 'trend reinforced by high gas storage levels', 'and a strong market outlook. '],
        [''],
        [''],
        ['Markets rally as Eurogas and IEA', 'raise concerns on possible energy', 'supply constraints if Europe faces a hard winter.'],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        ['Strikes at Australian LNG terminals', 'push prices upward.'],
        [''],
        [''],
        [''],
        ['Outbreak of war in the Middle East', 'threatens international oil and LNG markets,', 'whilst the Panama Canal is hit by drought.'],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        [''],
        ['Prices continue their decline', 'on warmer than forecast weather.'],
        [''],
    ];

    const mobileLabels = [
        ['Emerging from the energy crisis,', 'the year started off with high prices', 'reinforced by a cold spell in late 2022. '],
        ['Above average temperatures,', 'demand reduction measures,', 'and high gas storage levels send power', 'and gas prices trending downwards.'],
        ['Strike action at French LNG terminals', 'and North Sea Platforms cause supply', 'concern for gas filling season. '],
        [''],
        ['Markets remain on edge;', 'however, prices continue their downward', 'trend reinforced by high gas storage levels', 'and a strong market outlook. '],
        ['Markets rally as Eurogas and IEA', 'raise concerns on possible energy', 'supply constraints if Europe faces', 'a hard winter.'],
        [''],
        [''],
        ['Strikes at Australian LNG terminals', 'push prices upward.'],
        ['Outbreak of war in the Middle East', 'threatens international oil and LNG markets,', 'whilst the Panama Canal is hit by drought.'],
        [''],
        ['Prices continue their decline', 'on warmer than forecast weather.'],
    ];

    const init = () => {
        // Data for the chart
        const data = {
            labels: ['Jan.', '', '', '', 'Feb.', '', '', '', 'Mar.', '', '', '', '', 'Apr.', '', '', '', 'May', '', '', '', 'Jun.', '', '', '', '', 'Jul.', '', '', '', 'Aug.', '', '', '', 'Sep.', '', '', '', '', 'Oct.', '', '', '', 'Nov.', '', '', '', 'Dec.', '', '', '', ''],
            datasets: [
                {
                    type: 'line',
                    label: 'Power Price € (EEX)',
                    backgroundColor: '#013B2F',
                    borderColor: '#013B2F',
                    borderWidth: 2.5,
                    data: [102, 73, 147, 170, 114, 143, 127, 114, 136, 119, 94, 77, 89, 120, 95, 99, 101, 93, 95, 74, 73, 63, 80, 105, 107, 79, 84, 79, 85, 84, 73, 67, 100, 122, 107, 101, 115, 80, 106, 74, 78, 95, 102, 62, 93, 90, 97, 132, 102, 86, 42, 21],
                    tension: 0.4,
                    pointStyle: false,
                    order: 3
                },
                {
                    type: 'line',
                    label: 'Gas Price € (TTF)',
                    backgroundColor: '#FFD002',
                    borderColor: '#FFD002',
                    borderWidth: 2.5,
                    yAxisID: 'y1',
                    data: [70, 66, 62, 60, 58, 56, 52, 51, 49, 46, 46, 41, 44, 47, 43, 41, 40, 37, 35, 31, 27, 24, 27, 35, 35, 34, 34, 28, 27, 29, 27, 32, 34, 36, 34, 33, 36, 37, 40, 32, 45, 47, 48, 43, 42, 44, 46, 44, 40, 35, 33, 33],
                    tension: 0.4,
                    pointStyle: false,
                    order: 2
                },
                {
                    type: 'line',
                    data: [null, null, 108, null, null, null, null, 115, null, null, null, 75, null, null, null, null, null, null, 85, null, null, 55, null, null, null, null, null, null, null, null, null, null, null, null, null, 75, null, null, null, 73, null, null, null, null, null, null, null, null, null, 75, null],
                    showLine: false,
                    backgroundColor: '#00d161',
                    borderColor: '#00d161',
                    borderWidth: 10,
                    radius: 10,
                    order: 1,
                    label: 'Annotations',
                    hoverRadius: 15,
                }
            ]
        };

        const mobileData = {
            labels: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'],
            datasets: [
                {
                    type: 'line',
                    label: 'Power Price (EEX)',
                    backgroundColor: '#013B2F',
                    borderColor: '#013B2F',
                    borderWidth: 2.5,
                    data: [118, 128, 103, 101, 82, 100, 78, 94, 101, 87, 91, 69],
                    tension: 0.4,
                    pointStyle: false,
                    order: 3
                },
                {
                    type: 'line',
                    label: 'Gas Price (TTF)',
                    backgroundColor: '#FFD002',
                    borderColor: '#FFD002',
                    borderWidth: 2.5,
                    yAxisID: 'y1',
                    data: [64, 54, 45, 43, 32, 31, 30, 33, 36, 43, 43, 36],
                    tension: 0.4,
                    pointStyle: false,
                    order: 2
                },
                {
                    type: 'line',
                    data: [110, 115, 75, null, 90, 55, null, null, 65, 75, null, 70],
                    showLine: false,
                    backgroundColor: '#00d161',
                    borderColor: '#00d161',
                    borderWidth: 7,
                    radius: 7,
                    order: 1,
                    label: 'Annotations',
                    hoverRadius: 7,
                }
            ]
        };

        // Get the canvas element
        if (!document.getElementById('myChart')) {
            return
        }
        const ctx = document.getElementById('myChart').getContext('2d');

        const getResponsiveOptions = () => {
            const isMobile = window.innerWidth <= 768;
        
            const prioritizedLabels = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
        
            const callbackFunction = function (value, index, values) {
                const label = this.getLabelForValue(value);
                if (prioritizedLabels.includes(label)) {
                    return label;
                }
        
                if (isMobile) {
                    // Mobile-specific logic to hide some labels
                    return '';
                }
        
                return label;
            };
        
            return {
                responsive: true,
                interaction: {
                    mode: isMobile ? 'index' : 'nearest',
                    intersect: false,
                },
                stacked: false,
                plugins: {
                    legend: {
                        labels: {
                            filter: function (legendItem, data) {
                                // Exclude the "Annotations" dataset from the legend
                                return legendItem.text !== 'Annotations';
                            },
                            pointStyle: 'circle',
                            usePointStyle: true,
                            padding: isMobile ? 20 : 30,
                        },
                        position: 'bottom',
                    },
                    tooltip: {
                        enabled: false,
                        usePointStyle: true,
                        callbacks: {
                            labelPointStyle: function (context) {
                                return {
                                    pointStyle: 'circle',
                                    rotation: 0,
                                };
                            },
                        },
                        filter: function (tooltipItem) {
                            // Exclude the "Annotations" dataset from the tooltip entirely
                            return tooltipItem.dataset.label !== 'Annotations';
                        },
                        position: 'nearest',
                        backgroundColor: '#b2f2d1',
                        titleColor: '#063A2F',
                        titleFont: {
                            size: isMobile ? 13 : 16,
                            weight: '500'
                        },
                        bodyFont: {
                            size: isMobile ? 13 : 16,
                        },
                        bodyColor: '#063A2F',
                        padding: isMobile ? 10 : 20,
                    },
                    annotation: {
                        annotations: isMobile ? generateMobileAnnotations(mobileCoordinates, mobileLabels) : generateAnnotations(coordinates, labels)
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            callback: callbackFunction,
                            maxRotation: 0, // To prevent rotating labels
                            autoSkip: false, // Ensure labels are not automatically skipped
                        },
                        grid: {
                            drawOnChartArea: false,
                        }
                    },
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        suggestedMin: 0,
                        suggestedMax: 180,
                        title: {
                            display: !isMobile,
                            text: 'Power EUR',
                            font: {
                                size: isMobile ? 13 : 16,
                                weight: '900'
                            }
                        },
                    },
                    y1: {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        suggestedMin: 0,
                        suggestedMax: 80,
                        title: {
                            display: !isMobile,
                            text: 'Gas EUR',
                            font: {
                                size: isMobile ? 13 : 16,
                                weight: '900',
                            },
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    },
                },
                onClick: (event) => {
                    const elements = myChart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
                    if (elements.length) {
                        const element = elements[0];
                        const datasetIndex = element.datasetIndex;
                        const index = element.index;
        
                        // Check if the clicked point is from the 'Annotations' dataset
                        if (myChart.data.datasets[datasetIndex].label === 'Annotations') {
                            // Hide all other annotations first
                            coordinates.forEach((_, i) => {
                                const annotationKey = `label-${i}`;
                                if (myChart.options.plugins.annotation.annotations[annotationKey]) {
                                    myChart.options.plugins.annotation.annotations[annotationKey].display = false;
                                }
                            });
        
                            const annotationKey = `label-${index}`;
                            if (myChart.options.plugins.annotation.annotations[annotationKey]) {
                                myChart.options.plugins.annotation.annotations[annotationKey].display = true;
                                myChart.update('none');
                            }
                        }
                    } else {
                        // Hide all label annotations when not clicking on a point
                        coordinates.forEach((_, index) => {
                            const annotationKey = `label-${index}`;
                            if (myChart.options.plugins.annotation.annotations[annotationKey]) {
                                myChart.options.plugins.annotation.annotations[annotationKey].display = false;
                            }
                        });
                        myChart.update('none');
                    }
                },
                onHover: (event) => {
                    const elements = myChart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
                    if (elements.length) {
                        const element = elements[0];
                        const datasetIndex = element.datasetIndex;
                        const index = element.index;
        
                        // Check if the hovered point is from the 'Annotations' dataset
                        if (myChart.data.datasets[datasetIndex].label === 'Annotations') {
                            const annotationKey = `label-${index}`;
        
                            // Show the corresponding label annotation without re-triggering the animation
                            if (myChart.options.plugins.annotation.annotations[annotationKey]) {
                                myChart.options.plugins.annotation.annotations[annotationKey].display = true;
                                myChart.update('none'); // Use 'none' to update without animation
                            }
                        }
                    } else {
                        // Hide all label annotations when not hovering over a point
                        coordinates.forEach((_, index) => {
                            const annotationKey = `label-${index}`;
                            if (myChart.options.plugins.annotation.annotations[annotationKey]) {
                                myChart.options.plugins.annotation.annotations[annotationKey].display = false;
                            }
                        });
                        myChart.update('none'); // Use 'none' to update without animation
                    }
                },
                onLeave: () => {
                    // Hide all label annotations when leaving the chart area
                    coordinates.forEach((_, index) => {
                        const annotationKey = `label-${index}`;
                        if (myChart.options.plugins.annotation.annotations[annotationKey]) {
                            myChart.options.plugins.annotation.annotations[annotationKey].display = false;
                        }
                    });
                    myChart.update('none'); // Use 'none' to update without animation
                },
            };
        };
        
        
        const getResponsiveDatasets = () => {
            return window.innerWidth <= 768 ? mobileData : data;
        };

        // Create the chart
        const myChart = new Chart(ctx, {
            data: getResponsiveDatasets(),
            options: {
                // Add animations 
                animation: false
            }
        });

        // Intersection Observer callback to enable animations
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                myChart.options.animation = {
                    x: {
                        type: 'number',
                        easing: 'easeInOutQuart',
                        duration: 800,
                        from: NaN, // the point is initially skipped
                        delay(ctx) {
                            if (ctx.type !== 'data' || ctx.xStarted) {
                                return 0;
                            }
                            ctx.xStarted = true;
                            return ctx.index * 100; // delay based on the index
                        }
                    },
                };
                myChart.update();
                observer.unobserve(entry.target); // Stop observing after animation runs
            }
        });
    };

        // Create the Intersection Observer
        const observer = new IntersectionObserver(observerCallback, {
            threshold: 0.1 // Adjust the threshold as needed
        });

        // Observe the chart element
        observer.observe(document.getElementById('myChart'));

        // Update chart options on window resize
        window.addEventListener('resize', () => {
            myChart.options = {
                ...myChart.options,
                ...getResponsiveOptions()
            };
            myChart.update();
        });

        // Initial setup
        myChart.options = {
            ...myChart.options,
            ...getResponsiveOptions()
        };
        myChart.update();
    };
    init();
}
